import { type IBusinessUnit, type IUser } from "@/interfaces/api/user.interface"
import { type IUserSettings } from "@/interfaces/api/user-settings.interface"
import { type IGroup } from "@/interfaces/api/group.interface"
import { BaseModel } from "@/models/base.model"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { ModelFactory } from "@/factories/model-factory"
import { Tenant } from "@/models/tenant.model.ts"
import { UserTenant } from "@/models/user-tenant.model"

export class User extends BaseModel implements IUser {
  public static className = "User" // Used for socket communication.

  public static verboseName = "gebruiker"

  id: string

  activeTenant: Tenant

  groups: IGroup[]

  userSettings: IUserSettings

  knownBusinessEntityContact?: KnownBusinessEntityContact

  userTenants: UserTenant[]

  businessUnits: IBusinessUnit[]

  email: string

  phoneNumber: string

  firstName: string

  lastName: string

  fullName: string

  password: string

  isStaff: boolean

  isSuperuser: boolean

  constructor(user: IUser, managed = false) {
    super(user)

    this.id = user.id
    this.activeTenant = ModelFactory.childModel(Tenant, user.activeTenant, managed)
    this.groups = user.groups
    this.userSettings = user.userSettings
    this.knownBusinessEntityContact = ModelFactory.childModel(
      KnownBusinessEntityContact,
      user.knownBusinessEntityContact,
      managed
    )

    this.userTenants = ModelFactory.childModels(UserTenant, user.userTenants, managed)
    this.businessUnits = user.businessUnits ?? []

    this.email = user.email
    this.phoneNumber = user.phoneNumber
    this.firstName = user.firstName
    this.lastName = user.lastName
    this.fullName = user.fullName
    this.password = user.password

    this.isStaff = user.isStaff
    this.isSuperuser = user.isSuperuser
  }

  public getLoginIdentifier(): string {
    return this.email ?? this.phoneNumber
  }
}
